import './styles/variables.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/catalog.css';
import './styles/studio.css';
import './styles/responsive.css';
import './styles/accessibility.css';
import { App } from './app.js';

const app = new App(document.querySelector('#app'));
app.start();

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch((error) => console.warn('Service worker registration failed:', error));
  });
}
